import { ICompany } from "./company.model";

export class IAddressBookSearchData {
    companyId: string;
    sortBy: string;
    sortOrder: string;
    filterString: string;
    companyName: string;
    pazesize: number;
    pageStartIndex: number;
    totalNumberOfRecords: number;
    resultSet: ICompany[];
    constructor(){
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/address-book/address-book-search-data.model.ts